
import instImg1 from "../images/gallery/1.jpg"
import instImg2 from "../images/gallery/2.jpg"
import instImg3 from "../images/gallery/3.jpg"
import instImg4 from "../images/gallery/4.jpg"
import instImg5 from "../images/gallery/5.jpg"
import instImg6 from "../images/gallery/6.jpg"
import instImg7 from "../images/gallery/7.jpg"
import instImg8 from "../images/gallery/8.jpg"
import instImg9 from "../images/gallery/9.jpg"
import instImg10 from "../images/gallery/10.jpg"
import instImg11 from "../images/gallery/11.jpg"
import instImg12 from "../images/gallery/12.jpg"

const gallery = [
     {
        id:"1",
        imag:instImg1,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"2",
        imag:instImg2,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
   
    {
        id:"3",
        imag:instImg3,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"4",
        imag:instImg4,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"5",
        imag:instImg5,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"6",
        imag:instImg6,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"7",
        imag:instImg7,
        title: 'Charity',
        subtitle: 'Health & Hope',
    },
    {
        id:"8",
        imag:instImg8,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
     {
        id:"9",
        imag:instImg9,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
     {
        id:"10",
        imag:instImg10,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
     {
        id:"11",
        imag:instImg11,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
     {
        id:"12",
        imag:instImg12,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
]

export default gallery;